import { Component, inject, signal, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

import { CoiView } from '../coi-view/coi-view';
import { PageTitleService } from '../../../services/page-title';

/**
 * Standalone Certificate page (/policies/certificate/:memberId) — renders the shared CoiView for a
 * member, with Print / Download ready. Reachable programmatically (e.g. from the success screen).
 */
@Component({
  selector: 'app-coi-page',
  standalone: true,
  imports: [CommonModule, ButtonModule, CoiView],
  templateUrl: './coi-page.html',
  styleUrls: ['./coi-page.css'],
})
export class CoiPage implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  private platformId = inject(PLATFORM_ID);
  readonly pageTitle = inject(PageTitleService).title;

  memberId = signal<number | null>(null);

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    const id = Number(this.route.snapshot.paramMap.get('memberId')) || 0;
    this.memberId.set(id > 0 ? id : null);
  }

  back() {
    this.location.back();
  }

  findAnother() {
    this.router.navigate(['/policies/certificates']);
  }
}
